const MANAGER_ROLES = ['GROUP_FLEET_MANAGER', 'FLEET_MANAGER'];
const STAFF_ROLES = [...MANAGER_ROLES, 'FLEET_OFFICER'];

/**
 * Hard delete: Group Fleet Manager + Fleet Manager only.
 * Fleet Officers may edit but cannot delete.
 */
export function canHardDelete(role, entityType) {
  if (!role) return false;
  return MANAGER_ROLES.includes(role);
}

/** Create / edit fleet records: GFM, Fleet Manager, and Fleet Officer. */
export function canEditFleetRecord(role) {
  return STAFF_ROLES.includes(role);
}

/** Master-data export: Group Fleet Manager + Fleet Manager only. */
export function canExportMasterData(role) {
  return MANAGER_ROLES.includes(role);
}

/** Edit pending maintenance: staff or the submitting driver. */
export function canEditMaintenanceRequest(role, isPersonalView, request) {
  if (!request || request.status !== 'PENDING') return false;
  if (canEditFleetRecord(role) && !isPersonalView) return true;
  return !!isPersonalView;
}

/** Edit logbook: staff (all) or driver/user in personal view. */
export function canEditLogbookEntry(role, isPersonalView) {
  return canEditFleetRecord(role) || isPersonalView;
}

export function canEditPreTripChecklist(role, isPersonalView, checklist, user) {
  if (!checklist) return false;
  if (canEditFleetRecord(role) && !isPersonalView) return true;
  const userDriverId = user?.driver_id || user?.id;
  return isPersonalView && checklist.driver_id === userDriverId;
}
